export default "__VITE_ASSET__CA2M9WIt__"